
import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'orderByField',
    pure: false
})

export class OrderByField implements PipeTransform {
    transform(array: any[], field: string): any[] {
        array.sort((a: any, b: any) => {
            if (a[field] < b[field]) {
            return -1;
            } else if (a[field] > b[field]) {
            return 1;
            } else {
            return 0;
            }
        });
        return array;
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/users/user-details/orderByField.pipe.ts